"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const distance_1 = require("./utils/distance");
exports.default = distance_1.getDistance;
//# sourceMappingURL=index.js.map